<!-- eslint-disable max-len -->
<template>
  <div class="relative py-3 sm:max-w-xl sm:mx-auto">
    <div
      class="absolute inset-0 bg-gradient-to-r from-cyan-400 to-blue-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl animate-wiggle-slow"
    ></div>
    <div class="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
      <div class="max-w-md mx-auto">
        <h1 class="text-8xl font-bold">{{ code }}</h1>
        <h2 class="text-xl leading-normal m-0" style="margin-top: 0.01rem">{{ header }}</h2>
        <hr class="mt-1" />
        <div class="mt-3">
          <p class="text">{{ message }}</p>
          <p class="mt-2">
            Attempted URL: <strong> {{ this.$router.currentRoute.path }}</strong>
          </p>
          <button
            class="text-blue-400 flex justify-right align-center hover:text-blue-500 mt-6"
            @click="$router.go(-1)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Go Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['header', 'message', 'code'],
};
</script>
